import type { Questionnaire, QuestionnaireItem } from '@medplum/fhirtypes';
import { isStandardDiagnosisTreatmentPlanTemplate } from '../../../../lib/chart/chartDocumentTemplates';
import { getTemplateCategory } from './templateTags';
import type { ValidationError } from './questionnaireValidation';

export const CLINICAL_FIELD_TYPE_EXT = 'https://unify.health/fhir/StructureDefinition/clinical-field-type';
export const TREATMENT_PLAN_DIAGNOSIS_MISSING_WARNING =
  'This treatment plan template has no diagnosis code field. Diagnosis will not sync to the episode of care or billing. Add a question with linkId suffix `-diagnosis-code`.';

function itemHasDiagnosisSemantics(item: QuestionnaireItem): boolean {
  if (item.linkId?.endsWith('-diagnosis-code')) return true;
  const clinicalFieldType = item.extension?.find((ext) => ext.url === CLINICAL_FIELD_TYPE_EXT)?.valueCode;
  return clinicalFieldType === 'diagnosis-code';
}

function questionnaireHasDiagnosisSemantics(items: QuestionnaireItem[] | undefined): boolean {
  for (const item of items ?? []) {
    if (itemHasDiagnosisSemantics(item)) return true;
    if (questionnaireHasDiagnosisSemantics(item.item)) return true;
  }
  return false;
}

/** Warn when a primary D&T treatment-planning template lacks diagnosis semantics. */
export function validateTreatmentPlanDiagnosisSemantics(questionnaire: Questionnaire): ValidationError[] {
  if (getTemplateCategory(questionnaire) !== 'treatment-planning') return [];
  if (!isStandardDiagnosisTreatmentPlanTemplate(questionnaire)) return [];
  if (questionnaireHasDiagnosisSemantics(questionnaire.item)) return [];

  return [{
    path: 'item',
    message: TREATMENT_PLAN_DIAGNOSIS_MISSING_WARNING,
    severity: 'warning',
  }];
}
